import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';
import { searchTags } from './tags_api';

import TagOption from './associated_tag_selector/tag_option';

export default function AssociatedTagSelector({ taskTaggedRecords, onCreateTaskTag, onModelAdded }) {
  const searchTagOptions = (inputValue, callback) => {
    searchTags(inputValue, (taskTags) => {
      const options = taskTags.filter((taskTag) => {
        const record = taskTaggedRecords.find(r => r.taskTagId === taskTag.id);
        return !record || record._destroy;
      }).map((tag) => {
        return { value: tag.id, label: tag.name, type: 'Contacts::TaskTag' };
      });

      callback(options.filter(Boolean));
    });
  };

  const loadTagsOptionsWithCreate = (inputValue, callback) => {
    const createTag = {
      type: 'addTag',
      label: 'Create Tag',
      onClick: onCreateTaskTag
    };

    if (isBlank(inputValue)) return callback([createTag]);

    searchTagOptions(inputValue, options =>  callback([...options, createTag]));
  };

  const loadTagOptions = (inputValue, callback) => {
    return onCreateTaskTag ?
      loadTagsOptionsWithCreate(inputValue, callback) : searchTagOptions(inputValue, callback);
  };

  const onSelected = (selection) => {
    if (!selection.type || selection.type === 'addTag')  return;

    onModelAdded({
      name: selection.label,
      taskTagId: selection.value
    });
  };

  return (
    <AsyncSelect
      autoFocus
      className="entity-selector"
      components={{ Option: TagOption }}
      defaultOptions={!!onCreateTaskTag}
      loadOptions={loadTagOptions}
      placeholder="Search Tags ..."
      value=""
      onChange={onSelected}
    />
  );
}

AssociatedTagSelector.propTypes = {
  taskTaggedRecords: PropTypes.array,
  onCreateTaskTag: PropTypes.func,
  onModelAdded: PropTypes.func.isRequired
};
